import { DeniedActionContainer, DeniedText, UnableToManageStateImage } from './style';

export const AppErrorFallback = () => (
  <DeniedActionContainer data-automation="AppErrorFallback">
    <UnableToManageStateImage />
    <DeniedText role="heading" aria-level="1">
      You don&apos;t have access to Hi Scribe. If you think this is a mistake please contact us at
      practice.support@econsult.health
    </DeniedText>
  </DeniedActionContainer>
);
